import { ReactNode, useEffect, useRef, useState } from "react"

import { HamburgerIcon } from "@chakra-ui/icons"
import {
  Box,
  Flex,
  IconButton,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
} from "@chakra-ui/react"
import { useLocation } from "react-router-dom"

import { useAppDispatch, useAppSelector } from "app/hooks"
import { useExtractPathDetails } from "pages/listing-details-with-step/src/common"
import LeftSectionForListingDetails from "pages/listing-details-with-step/src/left-section/left-section-for-listing-details"
import { selectCurrentPmc } from "store/auth/authSlice"
import {
  getPropertyDetailsApi,
  selectIsStepAccordionOpen,
  setIsGetPropertiesData,
} from "store/rbo/rboSlice"

const ListingAllStepLayout = (props: { children: ReactNode }) => {
  const { children } = props
  const dispatch = useAppDispatch()
  const location = useLocation()
  const currentPmc = useAppSelector(selectCurrentPmc)
  const isAccordionOpen = useAppSelector(selectIsStepAccordionOpen)
  const { unitID } = useExtractPathDetails() // Get propertyId from the URL
  const [isSidebarOpen, setSidebarOpen] = useState(false)

  const isCongratulationsPage = location?.pathname?.endsWith("/congratulations")

  // fetch get properties data API call
  useEffect(() => {
    if (currentPmc?.pmc_id && unitID) {
      dispatch(
        getPropertyDetailsApi({
          params: {
            pmcId: currentPmc.pmc_id,
            pmsUnitId: unitID,
          },
        }),
      ).catch(() => {})
    }
    return () => {
      dispatch(setIsGetPropertiesData()) // Reset state on component unmount
    }
  }, [dispatch, currentPmc?.pmc_id, unitID])

  // Scroll to the bottom of the window when accordion opens from calendar sync
  const childrenWrapper = useRef<HTMLDivElement | null>(null)
  useEffect(() => {
    if (isAccordionOpen) {
      setTimeout(() => {
        childrenWrapper?.current?.scrollTo({
          top: childrenWrapper?.current?.scrollHeight,
          left: 0,
          behavior: "smooth",
        })
      }, 50)
    }
  }, [isAccordionOpen])

  return (
    <Flex h='100vh' w='100vw'>
      {/* Hamburger Menu Button for Tablet & Mobile */}
      <IconButton
        display={{ base: "block", md: "block", lg: "none" }}
        icon={<HamburgerIcon fontSize={20} />}
        onClick={() => setSidebarOpen(true)}
        position='absolute'
        top={4}
        left={4}
        zIndex={10}
        aria-label='Open Sidebar'
      />

      <Box
        w='467px'
        minW='467px'
        h='full'
        overflow='auto'
        bg='#006F80'
        display={{ base: "none", lg: "block" }} // Hide on small screens
      >
        {/* Left Sidebar for Desktop View : Property Listing Data Show */}
        <LeftSectionForListingDetails />
      </Box>

      {/* Sidebar Drawer for Mobile & Tablet */}
      <Drawer
        isOpen={isSidebarOpen}
        placement='left'
        onClose={() => setSidebarOpen(false)}
      >
        <DrawerOverlay />
        <DrawerContent
          bg='#006F80'
          w={{ base: "320px", sm: "467px" }}
          minW={{ base: "320px", sm: "467px" }}
          maxH='100vh' // Ensure it does not exceed the viewport height
          overflowY='auto' // Enable scrolling inside the drawer
        >
          <DrawerCloseButton color='white' />
          <LeftSectionForListingDetails setSidebarOpen={setSidebarOpen} />
        </DrawerContent>
      </Drawer>

      <Box
        position='relative'
        w={{ base: "100%", lg: "calc(100% - 428px)" }}
        h='100%'
        bg='white'
      >
        <Box
          ref={childrenWrapper}
          w='full'
          overflow='auto'
          h={isCongratulationsPage ? "100%" : "calc(100% - 77px)"}
          pb={7}
          pt='60px'
          px={{
            base: 4,
            xsm: 6,
            md: "150px",
            lg: "70px",
            xl: "150px",
            xxll: "255px",
          }}
        >
          {/* (Right Section) Step wise */}
          {children}
        </Box>
      </Box>
    </Flex>
  )
}
export default ListingAllStepLayout
